import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { findApiKey } from "../../../../../api/ConfigsApi";
import { LoadingOverlay, Paper, Stack } from "@mantine/core";
import ApiKeyUse from "./ApiKeyUse";

const ApiEdit = () => {
  const { apiId } = useParams();
  const [apiProfile, setApiProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (apiId && apiId !== "none") {
      setLoading(true);
      findApiKey(apiId)
        .then((response) => setApiProfile(response.data.apikey_profile))
        .finally(() => setLoading(false));
    }
  }, [apiId]);

  return (
    <Paper
      component={Stack}
      gap={"xs"}
      p={"lg"}
      pos={"relative"}
      h={"100%"}
      mb={16}
      style={{ boxShadow: "#00000012 0 2px 6px", overflow: "hidden" }}
      pt={52}
    >
      {loading ? (
        <LoadingOverlay visible />
      ) : (
        <ApiKeyUse apiProfile={apiProfile} />
      )}
    </Paper>
  );
};

export default ApiEdit;
